/*
 * @Author: 刘康宁 869161591@qq.com
 * @Date: 2022-07-21 10:10:23
 * @LastEditors: YGQ
 * @LastEditTime: 2025-07-10 16:48:15
 * @FilePath: /oneid/src/router/index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Vue from 'vue'
import VueRouter from 'vue-router'
import cookie from 'js-cookie'

Vue.use(VueRouter)

const routes = [
  { path: '/', name: 'login', component: () => import('../views/login/login.vue') },
  { path: '/sso', name: 'sso', component: () => import('../views/login/sso.vue') },
  { path: '/dashboard', name: 'dashboard', component: () => import('../views/home/dashboard.vue') },
  { path: '/user', name: 'user', component: () => import('../views/home/user.vue') },
  // { path: '/404', name: '404', component: () => import('../views/error/404.vue') },
  { path: '*', redirect: '/' }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// 全局导航守卫
router.beforeEach((to, from, next) => {
  const token = cookie.get('TOKEN')
  const user = JSON.parse(localStorage.getItem('user'))
  const isLoggedIn = token && user?.name
  const toPath = to.path
  const toQuery = to.query
  
  // 退出登录
  if (toPath === '/' && toQuery?.logout == 1) {
    cookie.remove('TOKEN')
    localStorage.removeItem('user')
    return next('/')
  }
  // 已登录访问首页跳转工作台
  if (toPath === '/' && isLoggedIn) return next('/dashboard')
  // 未登录，没有重定向地址，统一重定向首页
  if (toPath !== '/' && !isLoggedIn && !toQuery?.redirect_url) return next('/')
  next()
})

export default router
